import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { pathNames } from '../utilities/routing-path-utils';
import { AppComponentEventsService } from '../events/app-component-events.service';
import { UserResponse } from '../models/responses/user-response';
import { getConnectedUserFromLocalStorage } from '../utilities/user-utils';
import { PaymentPlan } from '../models/enums/payment-plan';

@Injectable({
  providedIn: 'root'
})
export class WhiteLabelGuardService {

  constructor(private authenticationService: AuthenticationService, private router: Router, private appComponentEventService: AppComponentEventsService) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const connectedUser: UserResponse = getConnectedUserFromLocalStorage();

    if (connectedUser) {
      if (connectedUser.paymentSettings && connectedUser.paymentSettings.payed) {
        return [PaymentPlan.DISCOUNTED, PaymentPlan.WHITELABEL].includes(connectedUser.paymentSettings.paymentPlan);
      }
    }

    this.router.navigate(['/' + pathNames.paymentPlansPath]);
    alert('You must be white labeled to access this page')    
    return false;
  }
}